export default {
    basicConfig: {
        schibstedAccInfoUrl: 'https://info.privacy.schibsted.com/no/hva-er-en-schibsted-konto/ ',
        schibstedAccountUrl: `https://${CONFIG.spid.server}/account/summary`,
        newslettersConfig: {},
        datePickerDateFormat: 'dddd Do MMMM',
        privacyPolicyUrl: 'https://schibsted.com/schibsteds-personvern-og-cookieerklaering/',
    },
};
